import { i18n } from "@lingui/core";
import React from 'react';
import { useLingui } from '@lingui/react';
import './copyright.scss';

var Copyright = function Copyright() {
  var _useLingui = useLingui(),
      i18n = _useLingui.i18n;

  return /*#__PURE__*/React.createElement("small", {
    className: "copyright"
  }, "\xA9 ", new Date().getFullYear(), " ", i18n._(
  /*i18n*/
  i18n._("kento takeuchi")));
};

export default Copyright;